import React, { useMemo } from 'react'
import { formFieldNames } from '.'
import { FormFieldContainer, RadioButtonsContainer, StyledRequired, StyledLabel } from 'components/form-fields/shared-style'
import { StyledHeading, StyledPageHeader, StyledParagraph, StyledProcessText } from './style'
import Radio from 'components/form-fields/radio'
import { useFormContext } from 'react-hook-form'
import { translate } from 'locales/i18n'

const FormStep1: React.FC = () => {
  const { watch } = useFormContext()
  const appTypeOptions = useMemo(() => [
    translate('forms.step1.offerType.option1'),
    translate('forms.step1.offerType.option2'),
    translate('forms.step1.offerType.option3')
  ], [translate]
  )
  const watchCurrentStep = watch(formFieldNames.CURRENT_STEP)

  return (
    <div>
      <StyledPageHeader>
        <div>
         <StyledHeading>
             {translate('forms.step1.heading')}
         </StyledHeading>
        </div>
        <StyledProcessText>
            {translate('forms.steps', { watchCurrentStep })}
        </StyledProcessText>
      </StyledPageHeader>
      <StyledParagraph>
          {translate('forms.step1.paragraph')}
      </StyledParagraph>
      <FormFieldContainer>
        <StyledLabel>
            <StyledRequired>*</StyledRequired>
            {translate('forms.step1.cta')}
        </StyledLabel>
        <RadioButtonsContainer>
        {appTypeOptions.map((value, index) => {
          return (
            <Radio
              key={value}
              name={formFieldNames.APPLICATION_TYPE}
              label={value}
              placeholder='Placeholder'
              value={value}
            />
          )
        })}
        </RadioButtonsContainer>
      </FormFieldContainer>
  </div>
  )
}

export default FormStep1
